import { Payment, PaymentHistoryResponse, TableActiveState } from "../../pages/Payment/payment.types";
import { CreatePaymentLink } from "../../pages/Payment/CreatePaymentLink/CreatePaymentLink/Steps/CreatePaymentLinkSchema";

export const getPaymentsHistoryResponseFormatter = (data: PaymentHistoryResponse): { items: Payment[]; meta: any } => {
  const FORMATTED_DATA = {
    ...data,
    items: data.items.map((item: any) => ({
      id: item.id,
      invoiceNum: `INV${item.id}`,
      amount: item.amount / 100,
      status: item.status,
      paidBy: item.customerInfo?.name || "N/A",
      email: item.customerInfo?.email || "N/A",
      category: item.paymentLink.category,
      paidAt: item.statusSetAt,
      created: item.createdAt,
    })),
  };

  return FORMATTED_DATA;
};

export const formatCreatePaymentLinkBody = (body: CreatePaymentLink) => {
  return {
    ...body,
    currency: body.currency.toLocaleLowerCase(),
    expiresAt: body.expiryDate,
    description: body.paymentFor,
    category: body.paymentCategory.toUpperCase(),
    amount: Number(body.amount) * 100,
  };
};

export function getTotalPaymentsPerDayRequestParamsFormatter(minDate?: Date | null, maxDate?: Date | null): string {
  const params = new URLSearchParams();

  if (minDate) {
    params.append("dateFrom", minDate.toISOString());
  }

  if (maxDate) {
    params.append("dateTo", maxDate.toISOString());
  }

  const URL_PARAMS = minDate && maxDate ? `?${params.toString()}` : "";
  return URL_PARAMS;
}

export function getPaymentsOverviewRequestParamsFormatter(minDate?: Date | null, maxDate?: Date | null): string {
  const params = new URLSearchParams();

  if (minDate) {
    params.append("dateFrom", minDate.toISOString());
  }

  if (maxDate) {
    params.append("dateTo", maxDate.toISOString());
  }

  const URL_PARAMS = minDate && maxDate ? `?${params.toString()}` : "";
  return URL_PARAMS;
}

export function getPaymentsHistoryRequestParamsFormatter({
  page,
  limit,
  search,
  status,
}: {
  page: number;
  limit: number;
  search?: string;
  status?: TableActiveState;
}): string {
  const params = new URLSearchParams();
  params.append("limit", limit.toString());
  params.append("offset", (page * limit).toString());

  if (search) params.append("search", search);
  if (status) params.append("status", status);

  return `?${params.toString()}`;
}

export function getPaymentLinksRequestParamsFormatter({
  page,
  limit,
  searchValue,
  minDate,
  maxDate,
  status,
}: {
  page: number;
  limit: number;
  searchValue?: string;
  minDate: Date | null;
  maxDate: Date | null;
  status: string;
}): string {
  const params = new URLSearchParams();
  params.append("limit", limit.toString());
  params.append("offset", (page * limit).toString());

  if (searchValue) params.append("search", searchValue);

  if (minDate) {
    params.append("dateFrom", minDate.toISOString());
  }

  if (maxDate) {
    params.append("dateTo", maxDate.toISOString());
  }

  if (status && status !== "all") {
    params.append("status", status === "open" ? "active" : status);
  }

  return `?${params.toString()}`;
}

export const createPaymentAccountFormatter = (data: any) => {
  const {
    paymentMethod,
    country,
    walletType,
    phoneNumber,
    email,
    accountType,
    currency,
    accountHolderName,
    bankName,
    ibanNumber,
    bankCodeSwift,
  } = data;

  let formattedData = {};

  switch (paymentMethod) {
    case "bankAccount":
      formattedData = {
        type: "bank",
        fullName: accountHolderName,
        iban: ibanNumber,
        bankName,
        swift: bankCodeSwift,
        email,
      };
      break;
    case "wallet":
      if (country === "egypt") {
        formattedData = {
          type: "e_wallet",
          phoneNumber,
          eWalletType: walletType,
          email,
          countryId: 62,
        };
      } else {
        formattedData = {
          type: "e_wallet",
          currency: currency,
          accountType,
          email,
        };
      }
      break;
    default:
      break;
  }
  return formattedData;
};
